import { filter, first } from 'lodash'
import { useMemo } from 'react'
import reviewDemoApi from 'src/api/reviewDemoApi'
import ticketApi from 'src/api/ticketApi'
import technicalTicketApi from 'src/api/technicalTicketApi'
import { useGetData } from 'src/hooks/useGetData'
import { isPastTimeV2 } from 'src/libs/util'
import useGetWithContext from 'src/hooks/useGetWithContext'
import { classDemoHelper } from 'src/libs/role-permission.helper'

export function useGetTechnicalTicketByStudent (
  sessionId,
  studentId,
  option
) {
  const { dependency } = option || {}
  const { data: technicalTicketData, status, reload } = useGetData(
    technicalTicketApi.listBySession,
    sessionId,
    { isDisabled: !sessionId },
    [dependency]
  )
  const technicalTickets = filter(
    technicalTicketData?.content || [],
    technicalTicket => technicalTicket?.studentId === studentId
  )
  return { technicalTickets, status, reload }
}

export function useGetMonitorTicketBySession (session) {
  const payloadFindTicket = useMemo(() => {
    if (session?.id) {
      return {
        page: 0,
        size: 1,
        criteria: [
          { field: 'type', operator: 'EQUAL', value: 'MONITOR_CLASS' },
          {
            field: 'targetId',
            operator: 'EQUAL',
            value: session.id
          }
        ]
      }
    }
    return null
  }, [session])

  const { data: ticketMonitor } = useGetData(
    ticketApi.listTicketMonitorFilter,
    payloadFindTicket,
    {
      isDisabled: !payloadFindTicket
    }
  )
  return first(ticketMonitor?.content)
}

export function useGetFbTicketByStudentAndSession ({ session, studentId }) {  
  const { canViewTicketFeedback } = classDemoHelper()

  const payloadFindTicket = useMemo(() => {
    if (!!session && !!studentId) {
      return {
        page: 0,
        size: 1,
        criteria: [
          // { field: 'type', operator: 'EQUAL', value: 'REVIEW_DEMO_CLASS' },
          { field: 'classDemoId', operator: 'EQUAL', value: session?.id },
          { field: 'studentId', operator: 'EQUAL', value: studentId, type: 'Long' }
        ]
      }
    }
    return false
  }, [session?.id, studentId])

  const { data: ticketFb } = useGetData(reviewDemoApi.filter, payloadFindTicket, {
    isDisabled: !payloadFindTicket || !isPastTimeV2({ date: session?.learnDate, time: session.startTime }) || !canViewTicketFeedback
  })
  return ticketFb?.content[0]
}
